import type { SiteNavView } from "@softmax/web-ux/shell";
import type { ComponentProps } from "react";
import type { CoworldNav } from "../coworld-menu";
import { getStartedLink, navAboutLinks, type SiteLink } from "../site-links";
import { siteShape } from "../site-shape";
import { browseDoor } from "./navigation-destinations";

type NavigationLayout = {
  readonly railPresent: boolean;
  readonly inProduct: boolean;
  readonly appBar: boolean;
  readonly showSwitcher: boolean;
  readonly showSearch: boolean;
  readonly menus: ComponentProps<typeof SiteNavView>["menus"];
};

export function navigationLayout({
  isSignedIn,
  hasRail,
  coworld,
  onboardingOpen,
  browseItems,
}: {
  readonly isSignedIn: boolean;
  readonly hasRail: boolean;
  readonly coworld: CoworldNav | undefined;
  readonly onboardingOpen: boolean;
  readonly browseItems: SiteLink[];
}): NavigationLayout {
  const railPresent = siteShape.signedInRail && hasRail;
  const inProduct = isSignedIn && hasRail;
  const appBar = !siteShape.signedInRail && inProduct;
  const menus =
    coworld || appBar
      ? []
      : [
          { label: "Browse", href: browseDoor.href, items: browseItems },
          // Signed out, Get Started is the action.
          ...(onboardingOpen ? [{ ...getStartedLink, items: [] }] : []),
          { label: "About", items: navAboutLinks },
        ];
  return {
    railPresent,
    inProduct,
    appBar,
    menus,
    showSwitcher: isSignedIn && !appBar && (railPresent || Boolean(coworld)),
    showSearch: isSignedIn && !appBar,
  };
}
